import { connect } from "react-redux";
import { DataProps, FunctionProps } from "src/common/types/utils";
import { pagePositionActions } from "src/features/pagePosition";
import { AppDispatch, AppState } from "../..";
import { Party, Props } from "../components/Party";
import { getIsOpenTable } from "../../openTable/selectors";
import { getVisibleMenuData } from "src/features/menu/selectors";

export function mapStateToProps(state: AppState, props: Props): DataProps<Props> {
    const isOpenTable = getIsOpenTable(state);
    const menuData = getVisibleMenuData(state);
    return {
        ...props,
        isOpenTable,
        hideProductImages: menuData?.hideProductImages,
    };
}

export function mapDispatchToProps(dispatch: AppDispatch): FunctionProps<Props> {
    return {
        animatingPage: (isServicePage: boolean) =>
            isServicePage
                ? dispatch(pagePositionActions.animatingServicePage(false))
                : dispatch(pagePositionActions.animatingMenuPage(false)),
    };
}

export const PartyContainer = connect(mapStateToProps, mapDispatchToProps)(Party);
